module.exports = __webpack_public_path__ + "static/media/draw-polygon.70570168.svg";